// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/spin/style/index.css
// module id = 834
// module chunks = 0